<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    filled
    dense
    :value="iValue"
  ></v-autocomplete>
</template>

<script>
  import RefreshOnDemand from '@/components/codelist/mixins/RefreshOnDemand'

  export default {
    name: 'DistributionArea',
    mixins: [
      RefreshOnDemand,
    ],
    computed: {
      key () {
        return 'distribution_area'
      },
    },
  }
</script>

<style scoped>

</style>
